import React from 'react';

import { useDisplayUsdcAsUsd } from '@/hooks/useDisplayUsdcAsUsd';
import { LocaleContext } from '@/hooks/useTranslator';
import { Locale } from '@/types/locale';
import { formatAmount, FormatStyle } from '@/utility/formatAmount';

export interface CustomFormatter {
  format(value: number | null, currency: string): string;
}

export const useCurrencyFormatter = (): CustomFormatter => {
  const locale = React.useContext<Locale>(LocaleContext);
  const displayUsdcAsUsd = useDisplayUsdcAsUsd();

  return {
    format: (value: number | null, currency: string): string => {
      return formatAmount(locale, value, currency, FormatStyle.extended, 2, displayUsdcAsUsd);
    },
  };
};
